export const InitState = Object.freeze({
    NO: Symbol('InitState.NO'),
    YES: Symbol('InitState.YES'),
    ERROR: Symbol('InitState.ERROR'),
})